function nullToUndefined(data) {
  if (data === null) {
    return undefined;
  } else if (Array.isArray(data)) {
    return data.map(nullToUndefined);
  } else if (typeof data === 'object') {
    return Object.keys(data).reduce((acc, key) => ({
      ...acc,
      [key]: nullToUndefined(data[key]),
    }), {});
  }
  return data;
}

export default nullToUndefined;



// WEBPACK FOOTER //
// ./src/byob-cms/src/formLib/nullToUndefined.js